import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';


export default function DeliveryFailureForm({ reason, details, setReason, setDetails, submitting, disabled, onSubmit }) {

  return (
    <div className="border-t border-dashed border-stone-300 pt-5 mt-2">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="h-4 w-4 text-red-500" />
        <h2 className="text-sm font-semibold text-red-700">Failed Delivery</h2>
      </div>
      <p className="text-xs text-stone-500 mb-3">Use this if you were unable to complete the delivery.</p>
      <div className="space-y-3">
        <div>
          <label className="text-sm font-medium text-stone-700">Reason</label>
          <select
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            className="mt-1 w-full px-3 py-2 border border-stone-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-200"
            data-testid="fail-reason-select"
          >
            <option value="">Select a reason...</option>
            <option value="nobody_home">Nobody home</option>
            <option value="wrong_address">Wrong address</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <label className="text-sm font-medium text-stone-700">Details (optional)</label>
          <Textarea
            value={details}
            onChange={(event) => setDetails(event.target.value)}
            placeholder="Describe what happened..."
            rows={2}
            className="mt-1 bg-white resize-none"
            data-testid="fail-details-input"
          />
        </div>
        <Button
          onClick={onSubmit}
          disabled={!reason || submitting || disabled}
          className="w-full h-10 bg-red-600 hover:bg-red-700 text-white text-sm font-medium"
          data-testid="fail-delivery-submit"
        >
          {submitting ? (
            <><Loader2 className="h-4 w-4 mr-2 animate-spin" />Submitting...</>
          ) : (
            <><AlertTriangle className="h-4 w-4 mr-2" />Mark as Failed</>
          )}
        </Button>
      </div>
    </div>
  );
}
